<template>
  <b-form-group
    class="font-weight-semibold mb-0"
    :label="label">
    <v-select
      v-model="innerValue"
      v-bind="$attrs"
      multiple
      :options="options"
      :reduce="val => val[returnValue]"
      :placeholder="placeholder"
      clearable
      :label="labelOption"
      :return-value="returnValue"
    />
  </b-form-group>
</template>

<script>
export default {
  props: {
    valueModel: {
      type: Array,
      default: () => ([])
    },
    options: {
      type: Array,
      default: () => ([])
    },
    labelOption: {
      type: String,
      default: 'label'
    },
    returnValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.valueModel
      },
      set (val) {
        this.$emit('update:value-model', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-select {
  background: white;
}
::v-deep input.vs__search::placeholder {
  color: #B9B9C3;
}
</style>
